<template>
  <el-dialog title="预警区域" width="70%" v-model="visibleShow">
    <div style="height:70vh;width:100%">
      <my-map ref="mymapRef"></my-map>
    </div>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  nextTick
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates.js";

export default defineComponent({
  name: "HMapdrawArea",
  components: { MyMap },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const mymapRef = ref(null);
    const { reversePoint } = handleCoordinates();
    const state = reactive({
      arr: [
        [
          [108.00304751981379, 31.313930763331438],
          [108.8778818564334, 31.19920745362916],
          [108.55066763380987, 30.823407877906977],
          [107.86060787090693, 30.811878487393887],
          [108.00304751981379, 31.313930763331438]
        ]
      ],
      visibleShow: false
    });

    nextTick(() => {
      // const arr = state.arr.forEach(item => {
      //   item = item.map(i => {
      //     return reversePoint(i);
      //   });
      // });
      console.log(state.arr, "lllllllllllllllll;");
      setTimeout(() => {
        // 绘制区域
        mymapRef.value && mymapRef.value.drawArea(state.arr);
        // 到对应的点位
        mymapRef.value &&
          mymapRef.value.mapLocation([
            [108.00304751981379, 31.313930763331438]
          ]);
      }, 0);
    });
    watchEffect(() => {
      state.visibleShow = props.visible;
    });
    return {
      ...toRefs(state),
      mymapRef
    };
  }
});
</script>
